import { NgModule } from '@angular/core';
import { BackToSigninComponent } from './back-to-signin.component';
import { CommonModule } from '@angular/common';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  declarations: [BackToSigninComponent],
  imports: [CommonModule, NzButtonModule, TranslateModule],
  exports: [BackToSigninComponent],
})
export class BackToSignInModule {}
